import request from "@/utils/request";

/**
 * 上报浏览时长
 * @param {Object} data - 上报数据
 * @param {number} data.browse_module - 浏览模块 (0=首页, 1=社区, 2=文档, 3=学堂)
 * @param {string} data.browse_url - 浏览页面URL
 * @param {number} data.active_delta - 本次活跃时长（秒）
 * @param {number} data.loading_count - 滚动加载次数
 * @returns {Promise}
 */
export function reportBrowsingDuration(data) {
  return request({
    url: '/community/custom.php?module=front&mod=home&ac=browseDuration',
    method: 'post',
    data
  });
}
